import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";

// English is bundled synchronously (zero load time).
// Māori is imported dynamically (lazy) and only loaded when the user toggles.
// This keeps the initial bundle as small as possible.
const loadMi = () => import("./locales/mi.json").then((m) => m.default);

i18n.use(initReactI18next).init({
    lng: localStorage.getItem("language") ?? "en",
    fallbackLng: "en",
    defaultNS: "translation",
    resources: {
        en: { translation: en },
    },
    interpolation: {
        escapeValue: false, // React already escapes
    },
});

// Loads the Māori resource bundle on demand via a dynamic import.
// Called both on toggle (LanguageContext) and on mount when a saved "mi"
// preference is restored from localStorage - ensuring the bundle is always
// present before i18n.changeLanguage("mi") is invoked.
export async function loadMaori(): Promise<void> {
    if (i18n.hasResourceBundle("mi", "translation")) return;
    const mi = await loadMi();
    i18n.addResourceBundle("mi", "translation", mi, true, true);
}

export default i18n;
